import { array } from "yup"

export interface TblDecInvImportadoScopus{
 iddecinvimportadoscopus: number,
 idpersona: number,
 iddecinvproyectoprodtermin: number,
 scopusid: string,
 scopuseid: string,
 ultimoCambio: Date
}

export function  GetVoidTblDecInvImportadoScopus():TblDecInvImportadoScopus{
    return {
    iddecinvimportadoscopus: 0,
    idpersona: 0,
    iddecinvproyectoprodtermin: 0,
    scopusid: "",
    scopuseid: "",
    ultimoCambio: new Date(),
    }
}

export function SetTblDecInvImportadoScopus(data: any):TblDecInvImportadoScopus{
    return {
    iddecinvimportadoscopus: data.iddecinvimportadoscopus??0,
    idpersona: data.idpersona??0,
    iddecinvproyectoprodtermin: data.iddecinvproyectoprodtermin??0,
    scopusid: data.scopusid??"",
    scopuseid: data.scopuseid??"",
    ultimoCambio: data.ultimoCambio??new Date(),
    }
}

export function SetListTblDecInvImportadoScopus(data: Array<any>):Array<TblDecInvImportadoScopus>{
    let list: Array<TblDecInvImportadoScopus> = [];
    data.forEach((item) => {
        const registro: TblDecInvImportadoScopus = SetTblDecInvImportadoScopus(item)
        list.push(registro);
    });
    return list;
}